import { render, staticRenderFns } from "./Shell.vue?vue&type=template&id=10bbf609&scoped=true&"
import script from "./Shell.vue?vue&type=script&lang=js&"
export * from "./Shell.vue?vue&type=script&lang=js&"
import style0 from "./Shell.vue?vue&type=style&index=0&id=10bbf609&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bbf609",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VMain } from 'vuetify/lib/components/VMain';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VAppBar,VMain,VSpacer})
